import { colors, opacities } from 'const/colors'
import {
  ClientBrand,
  ClientDetail,
  ClientDocuments,
  ClientPalette,
  CustomBrandComponents,
  GetMarketingBannerConfig
} from '../../typings/brands'
import { translations } from './brandTranslations'
import clientInfo from './clientInfo'
import CsrAlertContent from './customComponents/CsrAlertContent'
import CustomNeedAssistanceContent from './customComponents/CustomNeedAssistanceContent'
import { accountNumberConfig } from './accountNumberConfig'
import {
  ContactUsBusinessHours,
  ContactUsPhoneNumber
} from './customComponents/CustomContactUsCSR'
import FaqQuestions from './customComponents/FaqQuestions'
import images from './images'
import features from './features'
import customerSupport from './customerSupport'
import workStationConfig from './workStationConfig'
import { cardNumberConfig } from './cardNumberConfig'

// All the values are temporary, update once received the details
const clientDetail: ClientDetail = {
  storeName: `${clientInfo.displayName} Commercial Credit Card Online Account Management`,
  creditAccount: `${clientInfo.displayName} Commercial Credit Account`,
  // No prox support
  payableAccount: '',
  payableAccountBRC: 'Phillips 66 Conoco 76/SYNCB',
  payableAccountAcronym: ``,
  messageTo: ``,
  securityLevel: '101101000110100110011',
  address: {
    brcLegalNameChange: {
      addressLine1: '',
      city: '',
      state: '',
      zipCode: ''
    },
    brcPaymentResearch: {
      addressLine1: '',
      city: '',
      state: '',
      zipCode: ''
    },
    brcCreditBureau: {
      addressee: '',
      addressLine1: '',
      city: '',
      state: '',
      zipCode: ''
    },
    payment: {
      streetNumber: '',
      postalCode: ''
    }
  },
  secureMessageSubjectOptions: [
    'Business Account Information',
    'Business Account Other Inquiries'
  ],
  welcomeMatConfig: {
    headingBrandName: 'Phillips 66 Commercial Credit Center',
    csDisplayName: 'Phillips 66 BRC Credit Card Services',
    csNumber: customerSupport.contactUsBrc
  }
}

const palette: ClientPalette = {
  primary: '#628395',
  secondary: '#11224B',
  primaryDark: '#00358E',
  backToTop: {
    shadow: opacities.greyEightyTwo,
    background: colors.white,
    icon: colors.greySixty,
    hover: {
      background: colors.link,
      icon: colors.greyTen
    },
    active: {
      background: colors.greySixty,
      icon: colors.greyTen
    }
  },
  cobrowse: {
    text: '#333333',
    hover: '#FFFFFF'
  },
  titleBar: '#34657F',
  cardHeader: {
    backgroundStart: '#244759',
    backgroundEnd: '#34657f'
  },
  menu: {
    text: '#34657F',
    border: '#34657F'
  },
  footerLink: '#34657F',
  assistanceBackground: '#D1D5DB',
  hoverBackground: 'rgba(1, 73, 144, 0.1)',
  header: {
    background: '#FFFFFF',
    text: '#000000',
    border: '#244759'
  },
  headerMenu: {
    color: '#000000',
    backgroundColorStart: '#34657f',
    backgroundColorEnd: '#244759'
  },
  modal: {
    backgroundStart: '#244759',
    backgroundEnd: '#34657f',
    text: '#FFFFFF'
  },
  offerSection: {
    background: '#D1D5DB',
    text: '#1F2937',
    border: '#628395'
  },
  welcomeMat: {
    backgroundColorStart: '#34657f',
    backgroundColorEnd: '#244759',
    link: '#34657F'
  },
  button: {
    primary: {
      text: '#FFFFFF',
      hover: '#394C57',
      active: '#34657F'
    },
    secondary: {
      text: '#34657F',
      hover: '#F5F8FA',
      active: '#34657F'
    },
    text: '#34657F',
    background: '#34657F'
  },
  navigation: {
    activeTabText: '#34657F',
    activeTabBorder: '#34657F',
    dropdownHover: '#E8F1FB',
    inactiveTabText: '#656565'
  },
  radio: {
    border: '#628395',
    background: '#628395',
    inactiveBorder: '#656565',
    focusBackground: '#628395'
  },
  radioGroupCard: {
    checkedBorder: '#628395',
    checkedBackground: '#B8D6E6'
  },
  checkbox: {
    border: '#628395',
    background: '#628395',
    font: '#FFFFFF'
  },
  field: {
    icon: '#1977D3',
    focus: '#628395',
    label: '#628395',
    background: '#E8F1FB'
  },
  datepicker: {
    navIcon: '#515151',
    shadow: 'rgba(0, 0, 0, 0.8)',
    disabled: '#e9e9e9',
    legend: {
      selectedDate: {
        fill: '#628395',
        border: '#628395',
        text: '#FFFFFF'
      },
      dueDate: {
        fill: '',
        border: '#1977D3',
        text: '#000000'
      }
    }
  },
  tooltip: {
    borderColor: '#d8d8d8',
    backgroundColor: '#ffffff',
    color: '#3b3c43'
  },
  loader: '#628395',
  body: 'transparent',
  link: '#004895',
  switch: {
    background: '#34657F'
  }
}

const brandDocument: ClientDocuments = {
  closeAccountForm: '',
  websiteUsage: '/commercial/common/website_usage_agreement.html',
  privacyPolicy: '/commercial/common/online_privacy_policy.html'
}

const getMarketingBannerConfig: GetMarketingBannerConfig = () => null

const customComponents: CustomBrandComponents = {
  CustomNeedAssistanceContent,
  CsrAlertContent,
  ContactUsBusinessHours,
  ContactUsPhoneNumber,
  FaqQuestions
}

const p66Brand: ClientBrand = {
  accountNumberConfig,
  cardNumberConfig,
  clientInfo,
  clientDetail,
  palette,
  images,
  brandDocument,
  getMarketingBannerConfig,
  customComponents,
  translations,
  features,
  workStationConfig
}

export default p66Brand
